import type { ReactNode } from 'react';

import { cn } from '../lib/cn.ts';

/** Осмысленное пустое состояние: что здесь будет и с чего начать. */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex animate-fade-in flex-col items-start gap-2 px-6 py-10', className)}>
      {icon ? (
        <div className="mb-1 grid size-10 place-items-center rounded-lg bg-ink text-accent ring-1 ring-ink-ring [&_svg]:size-5">
          {icon}
        </div>
      ) : null}
      <div className="font-display text-title font-bold">{title}</div>
      {description ? <p className="max-w-[46ch] text-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
